import { SET_USER_DETAILS_INITIAL_STATE } from "../users/actionTypes";
import {
  CHANGE_PASSWORD_ERROR,
  CHANGE_PASSWORD_FORM,
  CHANGE_PASSWORD_PENDING,
  CHANGE_PASSWORD_SUCCESS,
  CLEAR_CHANGE_PASSWORD_ERROR,
  CLEAR_DELETE_OTHERS_ACCOUNT_ERROR,
  CLEAR_DELETE_SELF_ACCOUNT_ERROR,
  CLEAR_DIRECT_CHANGE_PASSWORD_ERROR,
  CLEAR_SEND_RESET_PASSWORD_ERROR,
  CLEAR_TRANSFER_DEVICE_ERROR,
  CLEAR_TRANSFER_USER_ERROR,
  CLEAR_UPDATE_ORG_PREFERENCE_ERROR,
  CLEAR_UPDATE_USER_ERROR,
  CLOSE_CHANGE_PASSWORD_MODAL,
  CLOSE_DIRECT_CHANGE_PASSWORD_MODAL,
  CLOSE_EDIT_USER_MODAL,
  CLOSE_ORG_PREFERENCE,
  CLOSE_TRANSFER_DEVICE_MODAL,
  DELETE_OTHERS_ACCOUNT_ERROR,
  DELETE_OTHERS_ACCOUNT_PENDING,
  DELETE_SELF_ACCOUNT_ERROR,
  DELETE_SELF_ACCOUNT_PENDING,
  DIRECT_CHANGE_PASSWORD_ERROR,
  DIRECT_CHANGE_PASSWORD_FORM,
  DIRECT_CHANGE_PASSWORD_PENDING,
  OPEN_CHANGE_PASSWORD_MODAL,
  OPEN_DIRECT_CHANGE_PASSWORD_MODAL,
  OPEN_EDIT_USER_MODAL,
  OPEN_ORG_PREFERENCE,
  OPEN_TRANSFER_DEVICE_MODAL,
  ORG_PREFERENCE,
  SEND_RESET_PASSWORD_ERROR,
  SEND_RESET_PASSWORD_PENDING,
  SEND_RESET_PASSWORD_SUCCESS,
  SET_ASSIGNABLE_TRANSFER_USERS_LIST_ASYNC,
  SET_SUBORDINATES_USERS_LIST_ASYNC,
  TRANSFER_DEVICE_ERROR,
  TRANSFER_DEVICE_PENDING,
  TRANSFER_DEVICE_SUCCESS,
  TRANSFER_USER_ERROR,
  TRANSFER_USER_PENDING,
  TRANSFER_USER_SUCCESS,
  TRASFER_USERS_FORM,
  UPDATE_ORG_PREFERENCE_ERROR,
  UPDATE_USER_ERROR,
  UPDATE_USER_PENDING,
  UPDATE_USER_SUCCESS,
  USER_DETAILS,
  USER_DETAILS_ERROR,
  USER_DETAILS_PENDING,
  USER_DETAILS_SUCCESS
} from "./actionTypes";

const initialState = {
  //----------------------------------------USER-DETAILS------------------------------------------------------------------------------------------------
  isUserDetailsPending: false,
  errorMessage: null,
  userDetails: null,
  // loading: true,
  userDetailsError: false,
  //----------------------------------------USER-UPDATE-------------------------------------------------------------------------------------------------
  isEditUserModalOpen: false,
  updateUserErrorMessage: null,
  isUpdateUserPending: false,
  isUpdatedSuccess: false,
  //----------------------------------------RESET-PASSWORD----------------------------------------------------------------------------------------------
  isResetPasswordPending: false,
  resetPasswordError: null,
  //----------------------------------------CHANGE-PASSWORD---------------------------------------------------------------------------------------------
  passwordForm: {},
  isChangePasswordModalOpen: false,
  isChangePasswordPending: false,
  //----------------------------------------TRANSFER-DEVICES--------------------------------------------------------------------------------------------
  isTransferDeviceModalOpen: false,
  transferErrorMessage: null,
  isTransferDevicePending: false,
  isTransferUserPending: false,
  assignableTransferUsersList: [],
  transferForm: {},
  //----------------------------------------ORG-PREFERENCE----------------------------------------------------------------------------------------------
  orgPreference: null,
  isChangeOrgPreference: false,
  updateOrgPreferenceError: null,
  orgApplicationName: null,
  orgApplicationLogo: null,
  //---------------------------------------DIRECT-PASSWORD-FORM----------------------------------------------------------------------------------------
  directPasswordForm: null,
  isDirectChangePasswordModalOpen: false,
  isDirectChangePasswordPending: false,
  isDirectChangeErrorMessage: null,
  //---------------------------------------DELETE-SELF-ACCOUNT----------------------------------------------------------------------------------------
  isDeleteSelfAccountPending: false,
  deleteSelfAccountErrorMessage: null,
  //---------------------------------------DELETE-OTHERS'-ACCOUNT----------------------------------------------------------------------------------------
  isDeleteOtherAccountPending: false,
  deleteOtherAccountErrorMessage: null,

  searchValueAsync: "",
};

export default (localState = initialState, action) => {
  switch (action.type) {
    //----------------------------------------USER-DETAILS------------------------------------------------------------------------------------------------
    case SET_USER_DETAILS_INITIAL_STATE: {
      return {
        ...initialState,
      };
    }
    case USER_DETAILS: {
      const { user } = action.payload;
      return {
        ...localState,
        userDetails: user,
        userDetailsError: null,
      };
    }
    case USER_DETAILS_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        userDetailsError: errorMessage,
        isChangePasswordPending: false,
        userDetails: null,
        isUserDetailsPending: false,
      };
    }
    case USER_DETAILS_PENDING: {
      return {
        ...localState,
        isUserDetailsPending: true,
      };
    }
    case USER_DETAILS_SUCCESS: {
      return {
        ...localState,
        isUserDetailsPending: false,
      };
    }

    //----------------------------------------USER-UPDATE-------------------------------------------------------------------------------------------------
    case OPEN_EDIT_USER_MODAL: {
      return {
        ...localState,
        isEditUserModalOpen: true,
      };
    }
    case CLOSE_EDIT_USER_MODAL: {
      return {
        ...localState,
        isEditUserModalOpen: false,
        updateUserErrorMessage: null,
      };
    }
    case UPDATE_USER_PENDING: {
      return {
        ...localState,
        isUpdateUserPending: true,
      };
    }
    case UPDATE_USER_SUCCESS: {
      return {
        ...localState,
        isUpdateUserPending: false,
        isUpdatedSuccess: true
      };
    }
    case UPDATE_USER_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        updateUserErrorMessage: errorMessage,
        isUpdateUserPending: false,
      };
    }
    case CLEAR_UPDATE_USER_ERROR: {
      return {
        ...localState,
        updateUserErrorMessage: null,
        isUpdateUserPending: false,
        isUpdatedSuccess: false
      };
    }

    //----------------------------------------RESET-PASSWORD----------------------------------------------------------------------------------------------
    case SEND_RESET_PASSWORD_PENDING: {
      return {
        ...localState,
        isResetPasswordPending: true,
      };
    }
    case SEND_RESET_PASSWORD_SUCCESS: {
      return {
        ...localState,
        isResetPasswordPending: false,
      };
    }
    case SEND_RESET_PASSWORD_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        resetPasswordError: errorMessage,
      };
    }
    case CLEAR_SEND_RESET_PASSWORD_ERROR: {
      return {
        ...localState,
        resetPasswordError: null,
      };
    }

    //----------------------------------------CHANGE-PASSWORD---------------------------------------------------------------------------------------------
    case CHANGE_PASSWORD_FORM: {
      const { passwordForm } = action.payload;

      return {
        ...localState,
        passwordForm: passwordForm
      }
    }
    case OPEN_CHANGE_PASSWORD_MODAL: {
      return {
        ...localState,
        isChangePasswordModalOpen: true,
      };
    }
    case CLOSE_CHANGE_PASSWORD_MODAL: {
      return {
        ...localState,
        isChangePasswordModalOpen: false,
        errorMessage: null
      };
    }
    case CHANGE_PASSWORD_PENDING: {
      return {
        ...localState,
        isChangePasswordPending: true,
      };
    }
    case CHANGE_PASSWORD_SUCCESS: {
      return {
        ...localState,
        isChangePasswordPending: false,
      };
    }
    case CHANGE_PASSWORD_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        errorMessage: errorMessage,
        isChangePasswordPending: false,
      };
    }
    case CLEAR_CHANGE_PASSWORD_ERROR: {
      return {
        ...localState,
        errorMessage: null,
        isChangePasswordPending: false,
      };
    }

    //----------------------------------------TRANSFER-DEVICES--------------------------------------------------------------------------------------------
    case TRASFER_USERS_FORM: {
      const { transferForm } = action.payload;
      return {
        ...localState,
        transferForm: transferForm,

      };
    }
    case CLOSE_TRANSFER_DEVICE_MODAL: {
      return {
        ...localState,
        isTransferDeviceModalOpen: false,
      };
    }
    case OPEN_TRANSFER_DEVICE_MODAL: {
      return {
        ...localState,
        isTransferDeviceModalOpen: true,
      };
    }
    case TRANSFER_DEVICE_PENDING: {
      return {
        ...localState,
        transferErrorMessage: null,
        isTransferDevicePending: true,
      };
    }
    case TRANSFER_DEVICE_SUCCESS: {
      return {
        ...localState,
        isTransferDevicePending: false,
      };
    }
    case TRANSFER_DEVICE_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        transferErrorMessage: errorMessage,
        isTransferDevicePending: false,
      };
    }
    case CLEAR_TRANSFER_DEVICE_ERROR: {
      return {
        ...localState,
        transferErrorMessage: null,
        isTransferDevicePending: false,
      };
    }
    case SET_ASSIGNABLE_TRANSFER_USERS_LIST_ASYNC: {
      const { usersListAsync, searchValueAsync } = action.payload;
      return {
        ...localState,
        assignableTransferUsersList: usersListAsync,
        searchValueAsync
      };
    }
    case SET_SUBORDINATES_USERS_LIST_ASYNC: {
      const { usersListAsync, searchValueAsync } = action.payload;
      return {
        ...localState,
        subordinateUsersList: usersListAsync,
        searchValueAsync
      };
    }
    case TRANSFER_USER_PENDING: {
      return {
        ...localState,
        transferErrorMessage: null,
        isTransferUserPending: true,
      };
    }
    case TRANSFER_USER_SUCCESS: {
      return {
        ...localState,
        isTransferUserPending: false,
      };
    }
    case TRANSFER_USER_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        transferErrorMessage: errorMessage,
        isTransferUserPending: false,
      };
    }
    case CLEAR_TRANSFER_USER_ERROR: {
      return {
        ...localState,
        transferErrorMessage: null,
        isTransferUserPending: false,
      };
    }

    //----------------------------------------ORG-PREFERENCE----------------------------------------------------------------------------------------------
    case ORG_PREFERENCE: {
      const { orgPreference } = action.payload;
      return {
        ...localState,
        orgPreference: orgPreference,
        orgApplicationLogo: orgPreference && orgPreference.applicationLogo,
        orgApplicationName: orgPreference && orgPreference.applicationName,
      };
    }
    case OPEN_ORG_PREFERENCE: {
      return {
        ...localState,
        isChangeOrgPreference: true
      };
    }
    case CLOSE_ORG_PREFERENCE: {
      return {
        ...localState,
        isChangeOrgPreference: false
      };
    }
    case UPDATE_ORG_PREFERENCE_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        updateOrgPreferenceError: errorMessage
      };
    }
    case CLEAR_UPDATE_ORG_PREFERENCE_ERROR: {
      return {
        ...localState,
        updateOrgPreferenceError: null
      };
    }

    //-----------------------------------------------------DIRECT-PASSWORD-FORM---------------------------------------------------------------------------------
    case DIRECT_CHANGE_PASSWORD_FORM: {
      const { passwordForm } = action.payload;
      return {
        ...localState,
        directPasswordForm: passwordForm
      }
    }
    case OPEN_DIRECT_CHANGE_PASSWORD_MODAL: {
      return {
        ...localState,
        isDirectChangePasswordModalOpen: true,
      };
    }
    case CLOSE_DIRECT_CHANGE_PASSWORD_MODAL: {
      return {
        ...localState,
        isDirectChangePasswordModalOpen: false,
      };
    }
    case DIRECT_CHANGE_PASSWORD_PENDING: {
      return {
        ...localState,
        isDirectChangePasswordPending: true,
      };
    }
    case DIRECT_CHANGE_PASSWORD_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        isDirectChangeErrorMessage: errorMessage,
        isDirectChangePasswordPending: false,
      };
    }
    case CLEAR_DIRECT_CHANGE_PASSWORD_ERROR: {
      return {
        ...localState,
        isDirectChangeErrorMessage: null,
        isDirectChangePasswordPending: false,
      };
    }

    //-----------------------------------------------------DELETE-SELF-ACCOUNT---------------------------------------------------------------------------------
    case DELETE_SELF_ACCOUNT_PENDING: {
      return {
        ...localState,
        isDeleteSelfAccountPending: true,
      };
    }
    case DELETE_SELF_ACCOUNT_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        deleteSelfAccountErrorMessage: errorMessage,
        isDeleteSelfAccountPending: false,
      };
    }
    case CLEAR_DELETE_SELF_ACCOUNT_ERROR: {
      return {
        ...localState,
        deleteSelfAccountErrorMessage: null,
        isDeleteSelfAccountPending: false,
      };
    }

    //-----------------------------------------------------DELETE-OTHERS'-ACCOUNT---------------------------------------------------------------------------------
    case DELETE_OTHERS_ACCOUNT_PENDING: {
      return {
        ...localState,
        isDeleteOtherAccountPending: true,
      };
    }
    case DELETE_OTHERS_ACCOUNT_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        deleteOtherAccountErrorMessage: errorMessage,
        isDeleteOtherAccountPending: false,
      };
    }
    case CLEAR_DELETE_OTHERS_ACCOUNT_ERROR: {
      return {
        ...localState,
        deleteOtherAccountErrorMessage: null,
        isDeleteOtherAccountPending: false,
      };
    }

    default: {
      return localState;
    }
  }
};
